import { Endpoint } from '../endpoint';
import { RecursivePartial } from '@core/utils/react';
import { GCCalendarEventRequest, GCCalendarEventResponse } from '@business/entities/gc_calendar';

export function events(query?: Partial<GCCalendarEventRequest>) {
  return Endpoint.get<GCCalendarEventResponse[]>(`@gc/calendar-event`, { params: { ...query } });
}

export function addEvent(event: RecursivePartial<GCCalendarEventResponse>) {
  return Endpoint.post<GCCalendarEventResponse>(`@gc/calendar-event`, { data: { ...event } });
}

export function editEvent(event: RecursivePartial<GCCalendarEventResponse>, eventId: string) {
  return Endpoint.patch<GCCalendarEventResponse>(`@gc/calendar-event/${eventId}`, { data: { ...event, eventId } });
}

export function dragEvent(eventId: string, event: RecursivePartial<GCCalendarEventResponse>) {
  return Endpoint.patch<GCCalendarEventResponse>(`@gc/calendar-event/drag/${eventId}`, { data: { ...event, eventId } });
}

export function deleteEvent(eventId: string) {
  return Endpoint.delete<GCCalendarEventResponse>(`@gc/calendar-event/${eventId}`);
}

export function addEventToGoogleCalendar(eventId: string) {
  return Endpoint.patch<GCCalendarEventResponse>(`@gc/calendar-event/add-to-google/${eventId}`, { data: { ...event, eventId } });
}

export function getEvent(eventId: string, isPublic = false) {
  if (isPublic) {
    return Endpoint.get<GCCalendarEventResponse>(`@gc/public/calendar-event/${eventId}`);
  }
  return Endpoint.get<GCCalendarEventResponse>(`@gc/calendar-event/${eventId}`);
}

export function updateParticipantStatus(eventId: string, participantId: string, status: string) {
  return Endpoint.patch<void>(`@gc/public/calendar-event/${eventId}/participant/${participantId}/status`, {
    data: { status },
  });
}
